import React, { useState, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { CSSTransition } from 'react-css-transition'
import * as Sentry from '@sentry/browser'
import TransitionStyles from '../../lib/transitionStyles'
import Header from './Header'
import ParticipantCard from './ParticipantCard'
import Spinner from '../Spinner'
import Button from '../Button'
import CartStandalonePurchase from '../CartStandalonePurchase'
import AuthenticatedAPI from '../../lib/authenticatedAPI'
import { currentMembership } from '../../lib/booking'
import { isHourly } from '../../lib/utils'
import { totalOrderPrice } from '../../lib/standalonePurchase'

const ShoppingStep = ({ toggleItem, items, skus, steps, setStep, setErrorMsg }) => {
  const [isLoading, setIsLoading] = useState(true)
  const [renewable, setRenewable] = useState([])

  useEffect(() => {
    const fetchMemberships = async () => {
      try {
        const userInfo = await AuthenticatedAPI.get('cphill', '/users')
        const ownMembership = userInfo.memberships
          .filter(m => m.isBookersOwn && !m.status).pop()

        if (!ownMembership) throw new Error("No active membership associated with user, contact CopenHill support")

        const renewableParticipants = userInfo.participants
          .filter(p => p.membershipId) // Some legacy participants might not have membershipId
          .map(p => ({ ...p, membership: currentMembership(p, userInfo) }))
          .filter(p => !isHourly(p.membership.type) && !p.membership.status)

        setRenewable([
          ...(ownMembership && !isHourly(ownMembership.type) && [{
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            membership: ownMembership,
            membershipId: ownMembership.id
          }] || []),
          ...renewableParticipants
        ])
      } catch (error) {
        Sentry.captureException(error)
        setErrorMsg(error.message)
      } finally {
        setIsLoading(false)
      }
    }

    fetchMemberships()
  }, [])

  // Strange fix - throws an error in console without this (https://github.com/wikiwi/react-css-transition/issues/5)
  CSSTransition.childContextTypes = {}

  return (
    <>
      {isLoading ? (
        <Spinner />
        ) : (
          <CSSTransition {...TransitionStyles} transitionAppear active>
          <>
            <Header />
            <div className="flex flex-wrap mt-8">
              {renewable.length > 0 ? renewable.map((participant, index) => (
                <ParticipantCard
                  participant={participant}
                  index={index}
                  key={`participant-${participant.id}`}
                  toggleItem={toggleItem}
                  items={items}
                  skus={skus}
                />
              )) : (
                <p className="text-grey-dark text-center">
                  <FormattedMessage id="renewals.memberships.none-found" defaultMessage="No renewable memberships found" />
                </p>
                )}
            </div>
            {skus && skus.length > 0 && (
              <CSSTransition {...TransitionStyles} transitionAppear active>
                <div className="mt-12">
                  <CartStandalonePurchase
                    // items={items}
                    items={items}
                    skus={skus}
                  // totalOrderSum={this.totalOrderSum}
                  // totalOrderDiscount={this.totalOrderDiscount}
                  // insuranceMandatoryPrice={this.insuranceMandatoryPrice}
                  // couponInfo={couponInfo}
                  />

                  <div className="flex justify-end mt-8">
                    <Button onClick={() => setStep(steps.PAYMENT)} disabled={totalOrderPrice(items, skus) === 0}>
                      <FormattedMessage
                        id='giftcards.buttonGotoPayment'
                        defaultMessage='Go to payment'
                      />
                    </Button>
                  </div>
                </div>
              </CSSTransition>
            )}
          </>
        </CSSTransition>
        )}
    </>
  )
}

export default ShoppingStep